import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../utils/api';
import { toast } from 'react-toastify';


export const sendWizardEnquiryThunk = createAsyncThunk(
    'sendWizardEnquiryThunk',
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.sendWizardEnquiry(data);
            toast.success("Enquiry sent successfully");

            return response.status;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || "something went wrong");
        }
    }
);


export const getBomEnquiriesSlice = createAsyncThunk(
    'bom/getBomEnquiriesSlice',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.getBomEnquiry(data);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
);


const wizardSlice = createSlice({
    name: 'wizard',
    initialState: {
        wizardEnquiry: [],
        loading: false,
        error: null,
        page: 1,
        productDetails: {},
        refresh : false
    },
    reducers: {
        
        setWizardRefresh:(state,action)=>{
            state.refresh = !state.refresh
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(sendWizardEnquiryThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(sendWizardEnquiryThunk.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(sendWizardEnquiryThunk.rejected, (state, action) => {
                state.loading = false;
            })

           
    },
});

export const { setProductPage,setCartData,setCartRefresh } = wizardSlice.actions
export default wizardSlice.reducer;

